import React, { useEffect, useState } from "react";
import Navbar from "../../layouts/Navbar";
import "../../styles/AddBusiness.css";
import { PROVIDER_SIDEBAR_MENUS } from "../../constants/constants";
import ProviderSidebar from "../../layouts/ProviderSidebar";
import PropertyBasicForm from "../../components/provider/PropertyBasicForm";
import PropertyDescriptionForm from "../../components/provider/PropertyDescriptionForm";
import PropertyFileUploadForm from "../../components/provider/PropertyFileUploadForm";
import { FormProvider, useFormContext } from "../../context/FormContext";
import { useParams } from "react-router-dom";
import api from "../../api/config";
import { ToastContainer, toast } from "react-toastify";

const ProviderBusiness = () => {
  const params = useParams();
  const type = params?.type || "new";
  const { formData, setFormData } = useFormContext();

  const [activeMenu, setActiveMenu] = useState(
    PROVIDER_SIDEBAR_MENUS.PROPERTY_BASIC
  );
  const [temp, setTemp] = useState(false);
  const [loading, setLoading] = useState(type !== "new");
  const [providerDetail, setProviderDetail] = useState({});

  const propertyDetails = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/space-feed-details/${type}`);
      if (response.status === 200) {
        setProviderDetail(response?.data?.response);
        setFormData({
          ...formData,
          propertyBasic: {
            categoryId: response?.data?.response?.categoryId,
            name: response?.data?.response?.name,
            address1: response?.data?.response?.address1,
            address2: response?.data?.response?.address2,
            city: response?.data?.response?.city,
            state: response?.data?.response?.state,
            pin: response?.data?.response?.pin,
            latitude: response?.data?.response?.latitude,
            longitude: response?.data?.response?.longitude,
          },
          propertyDetails: {
            price: response?.data?.response?.spaceFeedDetails?.price,
            rent: response?.data?.response?.spaceFeedDetails?.rent,
            totalSpace: response?.data?.response?.spaceFeedDetails?.totalSpace,
            availableSpace:
              response?.data?.response?.spaceFeedDetails?.availableSpace,
            minAvailableSpace:
              response?.data?.response?.spaceFeedDetails?.minAvailableSpace,
            remainingLeaseTerm:
              response?.data?.response?.spaceFeedDetails?.remainingLeaseTerm,
            minSubLeaseTerm:
              response?.data?.response?.spaceFeedDetails?.minSubLeaseTerm,
            businessType:
              response?.data?.response?.spaceFeedDetails?.businessType,
            subBusinessType:
              response?.data?.response?.spaceFeedDetails?.subBusinessType,
            layout: response?.data?.response?.spaceFeedDetails?.layout,
            parking: response?.data?.response?.spaceFeedDetails?.parking,
            description:
              response?.data?.response?.spaceFeedDetails?.description,
          },
        });
      }
    } catch (error) {
      toast.error("Something went wrong");
      //console.logerror, "error");
    } finally {
      setTemp(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type !== "new") {
      propertyDetails();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Navbar />
      <ToastContainer />
      <main className="main-content">
        <div className="add-business-header py-3">
          <span className="px-2">List Your Space</span>
        </div>
        <hr className="add-business-section" />
        {/* <div className="container-fluid"> */}
        {/* <FormProvider> */}
          <div className="row px-3 ">
            <ProviderSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
            />

            {activeMenu === PROVIDER_SIDEBAR_MENUS.PROPERTY_BASIC && (
              <PropertyBasicForm
                temp={temp}
                setTemp={setTemp}
                loading={loading}
                params={{ ...params, type }}
                providerDetail={providerDetail}
                setActiveMenu={setActiveMenu}
              />
            )}

            {activeMenu === "Property Description" && (
              <PropertyDescriptionForm
                temp={temp}
                setTemp={setTemp}
                loading={loading}
                params={{ ...params, type }}
                providerDetail={providerDetail}
                setActiveMenu={setActiveMenu}
              />
            )}
            {activeMenu === "Images/Videos" && (
              <PropertyFileUploadForm
                temp={temp}
                setTemp={setTemp}
                loadingState={loading}
                params={{ ...params, type }}
                providerDetail={providerDetail}
                setActiveMenu={setActiveMenu}
              />
            )}
          </div>
        {/* </FormProvider> */}

        {/* </div> */}
      </main>
    </>
  );
};

export default ProviderBusiness;
